import { useEffect, useState } from "react";
import { MapContainer, GeoJSON, Marker, Tooltip } from "react-leaflet";
import { DivIcon } from "leaflet";
import { IStation } from "service/forbush/interface";
import { dayjs } from "tools/timezone";
import { getThaiMonth } from "tools/util";
import MarkerIcon from "asset/image/marker.svg";
import MarkerHoverIcon from "asset/image/marker_hover.svg";
import MarkerWarningIcon from "asset/image/marker_warning.svg";
import MarkerWarningHoverIcon from "asset/image/marker_warning_hover.svg";
import map from "asset/data/custom.geo.json";

type Props = {
  data: IStation[];
};

const Forbush = ({ data }: Props) => {
  const [animate, setAnimate] = useState<boolean>(false);
  const markerPosition = { lng: -120, lat: -30 };

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate((prevAnimate) => !prevAnimate);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <MapContainer center={markerPosition} zoom={2} scrollWheelZoom={true} zoomSnap={0} zoomDelta={0.25} style={{ height: "100vh", width: "100%", background: "#1E1E1E" }} zoomControl={false}>
      <GeoJSON
        data={map as any}
        style={() => ({
          weight: 1,
          color: "#999",
          fillColor: "#A9A9A9",
          fillOpacity: 1,
        })}
      />
      {data?.map((value, key) => {
        return (
          <Marker
            key={key}
            position={{ lat: value.lat, lng: value.lng }}
            icon={
              new DivIcon({
                className: "custom-marker-icon",
                html: `
                    <div style="display:block;text-align:center;display:flex;gap:10px;">
                      ${value.alert ? `<img src="${animate ? MarkerWarningHoverIcon : MarkerWarningIcon}" alt="T" style="width:32px;height:32px;"/>` : `<img src="${animate ? MarkerHoverIcon : MarkerIcon}" alt="T" style="width:32px;height:32px;"/>`}
                      <div style="background:white;padding: 1px 10px;color:#1C1A16;font-size:14px;border-radius:4px;font-family:Arial;white-space:nowrap;height:24px;margin-top:${key === 7 ? "4px" : "4px"}; ">
                        ${value.name}
                      </div>
                    </div>`,
              })
            }
          >
            <Tooltip>
              <div className="bg-[#292826] text-white px-4 py-2">
                <h3 className="text-[18px] mb-3 uppercase font-geometo">{value.name}</h3>
                <div>
                  <div className="flex">
                    <div className="w-[150px] text-[15px] text-[#eee]">อัตราการนับ</div>
                    <div className="text-md font-moonhouse text-left">{value.count_rate ? value.count_rate.toFixed(2) : ""}</div>
                  </div>
                  <div className="flex">
                    <div className="w-[150px] text-[15px] text-[#eee]">อัตราการนับอ้างอิง</div>
                    <div className="text-md font-moonhouse text-left">{value.count_rate_reference ? value.count_rate_reference.toFixed(2) : ""}</div>
                  </div>
                  <div className="flex">
                    <div className="w-[150px] text-[15px] text-[#eee]">%การเปลี่ยนแปลง</div>
                    <div className="text-md font-moonhouse text-left">{value.change_percentage ? `${value.change_percentage.toFixed(2)} %` : ""}</div>
                  </div>
                  {/* <div className="flex">
                    <div className="w-[150px] text-[15px] text-[#eee]">ดัชนี KP</div>
                    <div className="text-md font-moonhouse text-left">{value.kp_index}</div>
                  </div> */}
                  <div className="flex">
                    <div className="w-[150px] text-[15px] text-[#eee]">วันที่ปรับปรุงข้อมูล</div>
                    <div className="font-semibold text-[14px] text-left">
                      {`${dayjs(value.datetime).format("DD")} ${getThaiMonth(parseInt(dayjs(value.datetime).format("M")))} ${dayjs(value.datetime).format("BBBB")}`} {dayjs(value.datetime).format("HH:mm")} น. (GMT+7)
                    </div>
                  </div>
                </div>
              </div>
            </Tooltip>
          </Marker>
        );
      })}
    </MapContainer>
  );
};

export default Forbush;
